import { autoCapitalize } from '@/utils/autoCapitalize'
import { CreditCardTypes } from './CreditCard.types'

class CreditCardListMapper {
  toDomain(persistenceData: CreditCardTypes) {
    return {
      id: persistenceData?.id,
      endAndFlagCard: `${persistenceData?.finalCartao} - ${autoCapitalize(
        persistenceData?.bandeira,
      )}`,
    }
  }
}

export default new CreditCardListMapper()
